import { Close } from '@radix-ui/react-popover';

export const PopoverClose = Close;
